export default {
  alertPersonalHeader: {
    ticker: 'ticker',
    alertName: 'alert',
    activate: 'activate',
    action: 'action',
  },
  confirmDel: {
    title: 'Delete Alert',
    content: 'Are you sure that you want to delete this alert?',
  },
  editSetting: {
    email: 'Email',
    notifications: 'Notifications',
    notificationPreferences: 'Notification Preferences',
    conditions: 'Conditions',
    applyTo: 'Apply to: %{ticker}',
  },
  deleteAlert: 'Delete this alert ?',
  delete: 'Delete',
  cancel: 'cancel',
};
